export default "__VITE_ASSET__CoH3UVI0hmDAlfmt7NhXQA__"